import { Component, Inject,OnInit,Renderer2, OnDestroy } from '@angular/core';
import {Subscription, interval} from 'rxjs';
import {MyOrder, Wishlist} from '../../shared/interfaces/MyAccount.interface';
import {DataService} from '../../shared/services/data.service';
import {HelperService} from '../../shared/services/helper.service';
import {ApiServices} from '../../shared/services/api.service';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Params, Router} from '@angular/router';
import { DOCUMENT, Location  } from '@angular/common';

import { Chart, ArcElement, LineElement, BarElement, PointElement, BarController, BubbleController, DoughnutController, LineController, PieController, PolarAreaController, RadarController, ScatterController, CategoryScale, LinearScale, LogarithmicScale, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, Filler, Legend, Title, Tooltip } from 'node_modules/chart.js';

import * as $ from 'jquery';

interface clickedVendor{
  vendor: string,
  is_approved: number
}

@Component({
  selector: 'app-suppliers',
  templateUrl: './suppliers.component.html',
  styleUrls: ['./suppliers.component.scss']
})
export class SuppliersComponent implements OnInit, OnDestroy {

  queryParams: Params;
  suppliersId:any = '';
  tab:any = '';
  product:any = '';  vendorCode:any = null;
  vendorCodeError: boolean = false;
  vendorCodeErrorMsg: string | null = null;

  delerVendors:Array<any> | null = null;
  basePathImage: string = 'https://d2iosncs8hpu1u.cloudfront.net/';
  showVendorDetail:boolean = false;
  vendorProfileDetail:Array<any> | null = null;
  vendorListData:any = null;
  showSpnier:boolean = false;
  vendorProducts:any = [];
  vendorProductsVariants:any = [];
  wheelSizeTypes:any = [];

  myOrders: any;
  showOrderDetail = false;
  showHideClass:any[];
  currentOrder: any;
  isVendorApproved:boolean = false;
  showProducts:any = true;

  selectedProdName:string='';
  selectedProdImg:string='';
  supplierLogo:string='';
  tabName:string='profile';  ts_user_data;
  current_tab='newSuppliers';
  allVendors: any[] = [];
  defaultUserImg = 'users/default.png';loadMoreProducts = false;
  hasNextPage = false;
  pagination:any = {
    page:1,
    perPage: 30
  }

  // Add polling variables for status checking
  private statusPollingSubscription: Subscription;
  private isPollingActive: boolean = false;

  constructor(
    private dataService: DataService,
    private helperService: HelperService,
    private apiService: ApiServices,
    private toastr: ToastrService,
    private router: Router,
    private location: Location,
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document) {

      const user_data_from_localstorage = localStorage.getItem("ts_user_data");
      if (user_data_from_localstorage) {
        this.ts_user_data = JSON.parse(user_data_from_localstorage)
      }
      activatedRoute.params.subscribe(param => {
        this.suppliersId = param.id;
        // this.product = param.product
        // console.log(param);
        if(this.suppliersId!='' && this.suppliersId!=undefined){
          this.showVendorDetail = true;
          let clickedVendor = localStorage.getItem("clickedVendor");
          let vendor_is_approved = false;
          if (clickedVendor) {
            const stringifiedVendor = JSON.parse(clickedVendor) as clickedVendor;
            if(this.suppliersId == stringifiedVendor.vendor) {
              vendor_is_approved = stringifiedVendor.is_approved == 1 ? true : false;
            }
          }          this.isVendorApproved = vendor_is_approved;
          this.VendorProfileDetail(this.suppliersId);
          this.getUserOrders(this.suppliersId);
          this.SupplierProducts(this.suppliersId, this.product);
          
          // Start polling if vendor is not approved yet
          if (!vendor_is_approved) {
            this.startStatusPolling();
          }
          // if(this.product == undefined){
          //   this.showProducts = true;
          // }else{
          //   // this.SupplierProductsVariants()
          //   this.showProducts = false;
          // }
        }
      });


    // Chart.register(ArcElement, LineElement, BarElement, PointElement, BarController, BubbleController, DoughnutController, LineController, PieController, PolarAreaController, RadarController, ScatterController, CategoryScale, LinearScale, LogarithmicScale, RadialLinearScale, TimeScale, TimeSeriesScale, Decimation, Filler, Legend, Title, Tooltip );

  }

  redirectToVendorProfile(vendor, isApproved:number = 0){
    let is_approved;
    if (isApproved == 0) {
      is_approved = vendor.is_approved == 1 ? 1 : 0
    } else {
      is_approved = 1;
    }
    localStorage.setItem("clickedVendor", JSON.stringify({vendor: vendor.id, is_approved: is_approved}))
    this.router.navigate([`/supplier/${vendor.id}`])
  }

 

  ngOnInit(): void {
    this.helperService.setPageTitle(this.activatedRoute.snapshot.data.title);
    this.getDealerVendors();
    this.getAllVendors();

    this.renderer.addClass(this.document.body, 'sidebarHide');
    this.renderer.addClass(this.document.body, 'supplier-bg');
  }

  requestVendorAccess(vendor_code=null){
    this.showSpnier = true;
    this.vendorCode = vendor_code;
    // console.log(this.vendorCode);
    if(this.vendorCode == null){
      this.vendorCodeError = true;
      this.vendorCodeErrorMsg = "This field is required.";
      this.showSpnier = false
      return false;
    } else {      this.apiService.requestVendor(this.vendorCode).subscribe(response => {        if (response.status) {
          this.vendorCodeError = false;
          this.vendorCodeErrorMsg = "";
          this.vendorCode = null;
          this.showSpnier = false;
          this.pagination.perPage = this.pagination.perPage * this.pagination.page;
          this.pagination.page = 1;
          this.allVendors = [];
          this.getAllVendors();
          this.toastr.success(response.message, 'Success');
          
          // Start polling for status updates after successful request
          this.startStatusPolling();
        } else {
          this.showSpnier = false;
          this.toastr.error(response.message, 'Error');
        }
      }, error => {
        this.showSpnier = false
        this.vendorCodeError = false;
        this.vendorCodeErrorMsg = "";
        this.toastr.error(error.error.message, 'Error');
      });
    }
  }

  getDealerVendors(){
    this.apiService.DealerVendors().subscribe(response => {
      if (response.status) {
        this.delerVendors = response.data.vendors;
        // console.log(this.delerVendors);
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  vendorCodeInput(event){
    this.vendorCode = event.target.value;
  }

  VendorProfileDetail(vendorId){
    // vendorData.id
    this.vendorListData = [];
    this.apiService.getVendorProfile(vendorId, this.isVendorApproved).subscribe(response => {
      if (response.status) {
        // console.log(response.data);
        this.vendorProfileDetail = response?.data;
        this.vendorListData = response?.data?.vendor;
        this.showVendorDetail = true;
        this.supplierLogo = this.vendorListData?.logo;
        // this.showChart(response.data.monthly_report);

      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  downloadFile(order_id: number) {
    this.apiService.getOrderInvoiceFileContent(order_id).subscribe(response => {
      this.downloadBlob(response, `invoice_${order_id}.pdf`);
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  downloadBlob(blob: Blob, filename: string) {
    const link = document.createElement('a');
    const url = window.URL.createObjectURL(blob);
    link.href = url;
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
  }


  SupplierProducts(vendorId, prod=''){
    this.vendorProducts = [];
    this.wheelSizeTypes = [];
    const queryParams = Object.assign({}, this.queryParams);
    // console.log(this.product);
    this.apiService.getSupplierProducts(queryParams, vendorId, prod, this.isVendorApproved).subscribe(response => {
      if (response.status) {
        this.vendorProducts = response.data.products;
        this.wheelSizeTypes = this.vendorProducts.prod_variants;
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });

    // if(prod != 'undefined' && prod != ''){
    //   this.SupplierProductsVariants(vendorId, prod, this.vendorProducts.prod_variants[0].rim_diameter );
    // }
  }

  SupplierProductsVariants(vendorId, product, diameter){
    this.vendorProductsVariants =[];
    const queryParams = Object.assign({}, this.queryParams);
    this.apiService.getSupplierProductsVariants(vendorId, product, diameter).subscribe(response => {
      if (response.status) {
        this.vendorProductsVariants = response.data.sizes;
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  resetProductData($event, tab=''){
    this.tabName = tab;
    this.router.navigate(['/suppliers/', this.suppliersId]);
  }

  setTabNameTo($event, tab=''){
    this.tabName = tab;
  }


  getUserOrders(vendorId){
    this.apiService.getUserOrderInvoices(vendorId).subscribe(response => {
      if (response.status) {
        this.myOrders = response.data;
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  onViewOrder(order:any): void {
    this.showOrderDetail = true;
     this.currentOrder = null;
    this.apiService.getOrderById(order.id).subscribe(response => {
       if (response.status) {
        this.currentOrder = response.data;
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });
  }

  showChart(MonthlyReports: any[]){
    let labels: any[] = [];
    let values: any[] = [];
    MonthlyReports.forEach(function (value)  {
      labels.push(value.month);
      values.push(value.total);
    });
    var myChart = new Chart("myChart", {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [{
          label: 'Monthly Reports',
          data: values,
          backgroundColor: [
            'rgba(54, 162, 235, 0.2)',
          ],
          borderColor: [
            'rgba(54, 162, 235, 1)',
          ],
            borderWidth: 1
        }]
      },
      options: {
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }

  backToProducts(){
    this.showProducts = true;
    this.SupplierProducts(this.suppliersId);
    // this.location.replaceState('/supplier/'+this.suppliersId);
    // console.log('444444 ', this.showProducts);

  }

  redirectToVatiants(suppliers_id, slug, diameter, productName='', productImg='', productFinish = ''){
    // console.log([diameter]);
    // this.router.navigateByUrl('/supplier/'+this.suppliersId+'/'+slug);
    this.product = slug;
    this.selectedProdName = productName+' '+productFinish;
    this.selectedProdImg = productImg;
    this.showProducts = false;
    this.wheelSizeTypes = [];
    const queryParams = Object.assign({}, this.queryParams);
    this.apiService.getSupplierProducts(queryParams, suppliers_id, slug, this.isVendorApproved).subscribe(response => {
      if (response.status) {
        this.wheelSizeTypes = response.data.products.prod_variants;

        if(this.wheelSizeTypes.length > 0) {
          this.SupplierProductsVariants(this.suppliersId,slug, this.wheelSizeTypes[0].rim_diameter);
        }
      }
    }, error => {
      this.toastr.error(error.error.message, 'Error');
    });


    // this.SupplierProducts(suppliers_id, slug);
    // this.location.replaceState('/supplier/'+this.suppliersId+'/'+slug);
  }
  getWarehouseNames(order) {
    return order.item_qty.map(iq => iq.warehouse).map(ware => ware.warehouse_name).join(', ')
  }

  ngOnDestroy() {
     this.renderer.removeClass(this.document.body, 'sidebarHide');
     this.renderer.removeClass(this.document.body, 'supplier-bg');
     
     // Stop polling when component is destroyed
     this.stopStatusPolling();
  }
  getAllVendors(){
    var paramObj = {
        page : this.pagination.page,
        perPage : this.pagination.perPage
    }
    this.apiService.allVendors(paramObj).subscribe(response => {
      this.loadMoreProducts = false;
      if (response.data) {
        this.allVendors = [...this.allVendors, ...response.data];
        this.allVendors = this.allVendors.filter((vendor)=> vendor.is_approved != 1)
      }
      if (response.next_page_url) {
        this.hasNextPage = true;
      } else {
        this.hasNextPage = false;
      }
    }, error => {
      this.loadMoreProducts = false;
      this.toastr.error(error.error.message, 'Error');
    });
  }
  openTab(screen){
    this.allVendors = [];
    this.pagination.page = 1;
    this.pagination.perPage = 30;
    this.current_tab = screen;
    if(this.current_tab == 'mySuppliers'){
      this.getDealerVendors();
    }else if(this.current_tab == 'newSuppliers'){
      this.getAllVendors();
    }
  }
  loadMore = () => {
    this.loadMoreProducts = true;
    this.pagination.page = this.pagination.page + 1;
    this.getAllVendors();
  }
  hasCostPerWheel(): boolean {
    
    return this.currentOrder && this.currentOrder.order_items && this.currentOrder.order_items.some(item => item.cost_per_wheel !== null && item.cost_per_wheel !== '');
    
  }

  parseDate(date:string){
    const dateObj = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };
    return dateObj.toLocaleString('en-US', options);
  }
  transformStatus(value: number): any {
    if (value === 0) {
      return "PENDING";
    } else if (value === 1) {
      return "PROCESSING";
    } else if (value === 2) {
      return "SHIPPED";
    } else if (value === 3) {
      return "COMPLETED";    } else {
      return "REJECTED";
    }
  }

  // Method to start polling for vendor status updates
  startStatusPolling(): void {
    if (this.isPollingActive || !this.suppliersId) {
      return;
    }

    this.isPollingActive = true;
    // Poll every 10 seconds
    this.statusPollingSubscription = interval(10000).subscribe(() => {
      this.checkVendorStatus();
    });
  }

  // Method to stop polling
  stopStatusPolling(): void {
    this.isPollingActive = false;
    if (this.statusPollingSubscription) {
      this.statusPollingSubscription.unsubscribe();
    }
  }

  // Method to check vendor status
  checkVendorStatus(): void {
    if (!this.suppliersId) {
      return;
    }

    this.apiService.getVendorProfile(this.suppliersId, this.isVendorApproved).subscribe(response => {
      if (response.status && response.data) {
        const currentApprovalStatus = response.data.is_approved === 1;
        
        // If status changed from pending to approved
        if (!this.isVendorApproved && currentApprovalStatus) {
          this.isVendorApproved = true;
          
          // Update localStorage
          const clickedVendor = {
            vendor: this.suppliersId,
            is_approved: 1
          };
          localStorage.setItem("clickedVendor", JSON.stringify(clickedVendor));
          
          // Show success notification
          this.toastr.success('Vendor request has been approved!', 'Status Update');
            // Refresh vendor data
          this.VendorProfileDetail(this.suppliersId);
          this.SupplierProducts(this.suppliersId, this.product);
          
          // Stop polling since vendor is now approved
          this.stopStatusPolling();
        }
      }
    }, error => {
      // Silently handle errors for background polling
      console.error('Status check failed:', error);
    });
  }
}
